import '../sass/enquiries-form.scss';

(() => {
    const pristineScript = document.querySelector('#blenheim-schools-pristine-js');
    const $blocks = document.querySelectorAll('.block.enquiries-form');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $formErrors = $block.querySelector('.enquiries-form__form-errors');
        const $form = $block.querySelector('.enquiries-form__form');
        const $turnstile = $block.querySelector('.enquiries-form__form-turnstile');
        const $turnstileToken = $block.querySelector('.enquiries-form__form-turnstile-token');
        const $enquiryTypeField = $block.querySelector('[name="enquiry-type"]');
        const $schoolField = $block.querySelector('[name="school"]');

        let turnstileInstance, pristine, formSubmitted = false;

        const checkIfTurnstileReady = resolve => {
            const interval = setInterval(() => {
                if (!$turnstileToken.value) return;

                resolve(interval);
                clearInterval(interval);
            }, 100);
        };

        const submitForm = () => {
            fetch('/wp-json/blenheim-schools/enquiry', {
                method: 'POST',
                body: new FormData($form)
            }).then(async response => {
                const json = await response.json();

                return json;
            }).then(json => {
                if (json.errors) {
                    throw new Error(json.errors.join('<br />'));
                }

                if (json.success) {
                    const { successPage } = $form.dataset;

                    if (successPage) {
                        window.location.href = successPage;
                    }
                }
            }).catch(error => {
                if (error.message) {
                    $formErrors.innerHTML = error.message;
                    $formErrors.classList.add('enquiries-form__form-errors--show');
                }
            }).finally(() => {
                $form.classList.remove('enquiries-form__form--loading');

                turnstile.reset(turnstileInstance);
            });
        };

        const initEnquiryTypeField = () => {
            if (!$enquiryTypeField) return;

            const $schoolFieldDefaultOption = $schoolField?.querySelector('option[selected]');

            const { requiredPlaceholder, notRequiredPlaceholder } = $schoolField.dataset;

            $enquiryTypeField.addEventListener('change', () => {
                if ($enquiryTypeField.value === 'admission') {
                    $schoolField.required = true;
                    $schoolField.ariaRequired = true;
                    $schoolFieldDefaultOption.textContent = requiredPlaceholder;
                } else {
                    $schoolField.required = false;
                    $schoolField.ariaRequired = false;
                    $schoolFieldDefaultOption.textContent = notRequiredPlaceholder;
                }

                console.log(pristine);

                pristine.reset();

                pristine = new Pristine($form);

                if (formSubmitted) {
                    pristine.validate();
                }
            });
        };

        const initForm = () => {
            if (!$form) return;

            pristine = new Pristine($form);
            
            $form.addEventListener('submit', e => {
                e.preventDefault();

                formSubmitted = true;

                $form.classList.add('enquiries-form__form--loading');
                $formErrors.classList.remove('enquiries-form__form-errors--show');

                if (!pristine.validate()) {
                    $form.classList.remove('enquiries-form__form--loading');

                    return;
                }

                if ($turnstile) {
                    const waitUntilReady = new Promise(checkIfTurnstileReady);

                    waitUntilReady.then(() => {
                        if (!pristine.validate()) {
                            $form.classList.remove('enquiries-form__form--loading');

                            return;
                        }
                        
                        submitForm();
                    });
                } else {
                    submitForm();
                }
            });
        };

        window.onloadTurnstileCallback = () => {
            if (!$turnstile) return;

            turnstileInstance = turnstile.render($turnstile, {
                sitekey: $turnstile?.dataset?.sitekey,
                callback: id => {
                    $turnstileToken.value = id;
                }
            });
        };

        if (typeof Pristine !== 'undefined') {
            initForm();
        } else if (pristineScript) {
            pristineScript.addEventListener('load', () => {
                initForm();
            });
        } else {
            window.addEventListener('load', () => {
                const pristineScript = document.querySelector('#blenheim-schools-pristine-js');

                if (!pristineScript) return;

                initForm();
            });
        }

        initEnquiryTypeField();
    });
})();
